import { createFileRoute } from '@tanstack/react-router';
import { PreparerDashboard } from '@/features/preparer/dashboard/PreparerDashboard';
import { z } from 'zod';
import { BinderStage, ClientType } from '@ata-digital/client-tax-system-api-client';
import { userSettingQueryOptions } from '@/lib/query/options';

// Define search params schema for sticky filtering/sorting
const dashboardSearchSchema = z
  .object({
    // Master filters
    myClientsOnly: z.string().optional().catch(undefined), // 'true', 'false', or undefined (defaults to My Clients)
    assignedToMe: z.string().optional().catch(undefined), // 'true', 'false', or undefined (defaults to Assigned to Me)
    officeId: z.string().optional().catch(undefined),
    partnerId: z.string().optional().catch(undefined), // Filter by partner

    // Card filter
    activeCardFilter: z
      .enum(['commentsToReview', 'documentsToReview', 'clientSubmissions', 'returnsInProcess', 'lateDocuments'])
      .optional()
      .catch(undefined),

    // Table filters
    search: z.string().optional().catch(undefined),
    taxYear: z.number().int().optional().catch(undefined),
    taxType: z.nativeEnum(ClientType).optional().catch(undefined),
    stage: z.nativeEnum(BinderStage).optional().catch(undefined),
    isClientSubmitted: z.enum(['true', 'false']).optional().catch(undefined),

    // Table sorting
    sortField: z
      .enum([
        'clientName',
        'taxYear',
        'stage',
        'dueDate',
        'documentsTotal',
        'documentCompletionPercentage',
        'completionPercentage',
        'partnerName',
        'lastActivity',
      ])
      .optional()
      .catch(undefined),
    sortOrder: z.enum(['asc', 'desc']).optional().catch(undefined),
  })
  .passthrough(); // Allow unknown keys to pass through

export const Route = createFileRoute('/preparer/')({
  loader: async ({ context: { queryClient } }) => {
    const authState = queryClient.getQueryData(['auth', 'session']) as
      | { token?: string; isAuthenticated?: boolean }
      | undefined;

    if (authState?.token) {
      queryClient.prefetchQuery(userSettingQueryOptions.current(authState.token)).catch(() => {});
    }
  },
  component: PreparerDashboard,
  validateSearch: dashboardSearchSchema,
});
